<template>
    <div class="page flex-col">
        <div class="box_1 flex-col">
            <div class="group_2 flex-row">
                <div class="image-text_25 flex-row justify-between">
                    <img class="label_1" referrerpolicy="no-referrer" src="static/img/mobile/scanImage.png" @click="openScan" />
                    <!-- <span class="text-group_1">关键字搜索</span> -->
                    <el-input type="text" name="fname" class="text-group_1" placeholder="扫描腕带/输入住院号" :clearable="true" v-model="scan_userCode" ref="userCode" @change="loadAllTabData"/>
                </div>
            </div>
        </div>
            <div>
            <vtabs v-model="activeTab">
                <vtab v-for="(tab, index) in tabsGroup" :key="index" :title="tab.title" :name="tab.name"></vtab>
            </vtabs>
            <div class="section_2 flex-col">
                <div class="tabs_1 flex-col"></div>
                <div class="tabs_1 flex-col">
                    <vdropdownmenu>
                        <vdropdownitem title="手术时间" v-model="activeOperTime" :options="operTimes" @click.native="handlerOperTime()"/>
                        <vdropdownitem title="转运状态" v-model="activeTransferStatus" multiple :options="transferStatus" />
                        <vdropdownitem title="手术房间" ref="item">
                            <div class="dropdownRooms flex-col">
                                <!-- xunhuan -->
                                <div v-for="(ward, index) in operateWards" :key="index">
                                    <div v-if="ward.code == '手术区'">
                                        <div class="wardpanel">{{ ward.label }}</div>
                                        <div v-if="ward.operation_room && ward.operation_room.length > 0" class="roompanel">
                                            <div
                                                class="room"
                                                @click="selectedRooms(room.value, 1)"
                                                :class="{ room_active: selectedOperateRoomIds.indexOf(room.value) > -1 }"
                                                v-for="(room, r_idx) in ward.operation_room"
                                                :key="r_idx"
                                            >
                                                {{ room.label }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="wardpanel">
                                    复苏室
                                    <div class="roompanel">
                                        <div
                                            class="room"
                                            v-if="ward.code == '复苏室'"
                                            @click="selectedRooms(ward.origion, 2)"
                                            :class="{ room_active: selectedRecoveryRoomIds.indexOf(ward.origion) > -1 }"
                                            v-for="(ward, index) in operateWards"
                                            :key="index"
                                        >
                                            {{ ward.label }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="btnconfirm">
                                <vbutton type="primary" class="btnselectroom" @click="cancelSelectRooms" block round>
                                    重置
                                </vbutton>
                                <vbutton type="primary" class="btnselectroom" @click="confirmSelectRooms" block round>
                                    确认
                                </vbutton>
                            </div>
                        </vdropdownitem>
                    </vdropdownmenu>
                </div>
            </div>
            <vlist class="content" v-model="loading" :finished="finished" finished-text="" :style="{'height':`${ this.screenHeight - 200}px`}" @load="onLoad">
                <div v-if="transferInfoList.length > 0">
                    <div class="surgeryInfo" v-for="(transferInfo, index) in transferInfoList" :key="index">
                        <div class="header" @click="goTransDetail(transferInfo)">
                            <span class="name">{{ transferInfo.patient_name }}</span>
                            <span class="patientInfo">{{ transferInfo.surgery_info.sex || '--' }}/{{ transferInfo.age || '--' }}/{{ transferInfo.bed_no || '--' }}/{{ transferInfo.visit_no || '--' }}</span>
                            <span
                                ><vtag v-if="!transferInfo.transfer_circulation.color" plain type="primary">{{ transferInfo.transfer_status }}</vtag>
                                <vtag v-else :color="`rgb(${transferInfo.transfer_circulation.color})`" plain>{{ transferInfo.transfer_status }}</vtag></span
                            >
                        </div>
                        <div class="middle flex-row justify-between" @click="goTransDetail(transferInfo)">
                            <div class="surgery flex-col">
                                <div class="flex-row">
                                <span class="patientTitle">台次:</span>
                                <span class="patientContent">{{ transferInfo.scheduled_sequence }}</span>
                                </div>
                                <div class="flex-row rowmargin">
                                <span class="patientTitle">手术间:</span>
                                <span class="patientContent">{{ transferInfo.dic_operating_room }}</span>
                                </div>
                                <div class="flex-row rowmargin">
                                    <span class="patientTitle">术前诊断:</span>
                                    <span class="patientContent">{{ transferInfo.surgery_info.plan_diseases }}</span>
                                </div>
                            </div>
                            <div class="surgery flex-col">
                                <div class="flex-row">
                                    <span class="patientTitle">手术名称:</span>
                                    <span class="patientContent">{{ transferInfo.surgeries }}</span>
                                </div>
                                <div class="flex-row rowmargin">
                                    <span class="patientTitle">手术医生:</span>
                                    <span class="patientContent">{{ transferInfo.surgeon }}</span>
                                </div>
                                <div class="flex-row rowmargin">
                                    <span class="patientTitle">转运阶段:</span>
                                    <span class="patientContent">{{ transferInfo.next_transfer_circulation && transferInfo.next_transfer_circulation.flow_surgery_stage }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <vbutton class="btnTrans" type="info" v-if="transferInfo.transfer_status == '手术中'" @click="goPath(transferInfo,'ScoreInfo')">评分</vbutton>
                            <vbutton class="btnTrans" v-if="isHaveWithDrawRole(transferInfo)" type="info" @click="handlerTransfer(transferInfo, 2, '撤回')">撤回</vbutton>
                            <template v-if="transferInfo.next_transfer_circulation && transferInfo.next_transfer_circulation.buttonNames && isHaveHandRole(transferInfo.next_transfer_circulation)">
                            <vbutton class="btnTrans" type="info"
                            v-for="(bname, bindex) in transferInfo.next_transfer_circulation.buttonNames" :key="bindex" @click="handlerTransfer(transferInfo, 1, bname)">{{
                                bname
                            }}</vbutton>
                            </template>
                            <vbutton class="btnTrans" @click="goTransDetail(transferInfo)" type="info">转运详情</vbutton>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <vempty description="暂无数据" class="empty" />
                </div>
            </vlist>
            <vpopup v-model="showDatePickerPanel" round position="bottom">
                <vdatetimepicker
                    v-model="currentDate"
                    type="date"
                    title="手术计划开始时间"
                    @cancel="showDatePickerPanel = false"
                    @confirm="confirmOperTime"
                    :min-date="minDate"
                    :max-date="maxDate"
                />
            </vpopup>
            </div>
            <div class="section_5 flex-row" v-if="!user">
                <vtabbar v-model="activeBottomTabItem">
                    <vtabbaritem icon="bars" class="thumbnail_39 text-group_34">患者列表</vtabbaritem>
                    <vtabbaritem icon="bars" class="thumbnail_39 text-group_31">患者转运</vtabbaritem>
                    <vtabbaritem icon="comment-o" class="thumbnail_39 text-group_34">我的</vtabbaritem>
                </vtabbar>
            </div>
            <van-dialog v-model="showRemarkObj.isShow" title="备注" show-cancel-button @cancel="showRemarkObj.isShow = false" @confirm="confirmAddTransfer">
                <vfield class="dialogRemark" v-model="showRemarkObj.remark" type="textarea" placeholder="请输入注意事项,最多150字" rows="3" autosize />
            </van-dialog>
            <van-dialog v-model="document.dialogFormVisible" width="100%" show-cancel-button @cancel="document.dialogFormVisible = false"  @confirm="$refs.doc.confirm()" class="dialog-adverse">
                <!-- <DocFrame ref="doc" :style="{'height':`${ this.screenHeight - 60}px`}" :docno="document.docno" :guid="document.docguid" :surgeryId="document.surgeryId" docname="患者转运记录单" @saved="afterDocumentSaved"></DocFrame> -->
                <DocInfo ref="doc" :docId="document.docno" :doc="document.doc" :surgeryId="document.surgeryId" :isPagination="isPagination" @afterSaved="afterDocumentSaved"></DocInfo>
            </van-dialog>
    </div>

</template>

<script>
import axios from 'axios'
import DocInfo from '../DocInfo.vue'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import 'vant/lib/index.css'
import { Tab as vtab, Tabs as vtabs, DropdownMenu as vdropdownmenu, DropdownItem as vdropdownitem, Button as vbutton, PullRefresh as vpullrefresh, List as vlist, Empty as vempty, DatetimePicker as vdatetimepicker, Popup as vpopup, Tabbar as vtabbar, TabbarItem as vtabbaritem, Tag as vtag, Dialog, Field as vfield, Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
    name: `TransferList`,
    components: { DocInfo, vtab, vtabs, vdropdownmenu, vdropdownitem, vbutton, vpullrefresh, vlist, vempty, vdatetimepicker, vpopup, vtabbar, vtabbaritem, vtag, [Dialog.Component.name]: Dialog.Component, vfield, Toast },
    data() {
        return {
            scan_userCode: ``,
            scanActive: true,
            operTimes: [
                { text: `今天`, value: 0 },
                { text: `本周`, value: 1 },
                { text: `本月`, value: 2 },
                { text: `自定义时间`, value: 3 }
            ],
            activeOperTime: 0,
            transferGroupConfig: (this.$root.TransferGroupConfig && this.$root.TransferGroupConfig != `` && JSON.parse(this.$root.TransferGroupConfig)) || [],
            currentRoleConfig: null,
            tabsGroup: [],
            activeTab: `全部`,
            transferStatus: [],
            allTransferStatus: [],
            activeTransferStatus: `全部`,
            activeBottomTabItem: 1,
            loading: false,
            finished: false,
            refreshing: false,
            showDatePickerPanel: false,
            showRemarkObj: {
                isShow: false,
                id: 0,
                biz_surgery_info_id: 0,
                next_dic_transfer_circulation_id: 0,
                remark: ``,
                is_withdraw: false,
                next_dic_transfer_circulation: null
            },
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            transferCirculations: null,
            transferInfoList: [],
            allTransferInfoList: [],
            operateWards: [],
            selectOperateWards: [],
            selectedOperateRoomIds: [],
            selectedRecoveryRoomIds: [],
            orderGrabbingList: [], // 抢单集合
            messagebadge: 0,
            users: [],
            document: {
                // 当前打开的文书一些内容
                dialogFormVisible: false,
                docguid: ``,
                surgeryInfo: null,
                surgeryId: ``,
                docno: 0,
                doc: null
            },
            documentConfig: [],
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            isPagination: this.$root.MobileDocIsPagination == `1`,
            hospitalWardCode: this.$route.query.hospitalwardcode,
            visitNo: this.$route.query.visitno
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `hospital_ward_all`, `sysuser/workers`, `ward_auth`, `active_hospital_ward`])
    },
    created() {
        this.loadToken().then(() => {
            this.$store.dispatch(`ADD_HOSPITAL_WARD`).then((data) => {
                if (this.hospitalWardCode) {
                    let ward = this.hospital_ward_all.find(i => i.code == this.hospitalWardCode)
                    if (!ward) {
                        this.$message.error(`未匹配到院区！`)
                        return
                    }
                    console.log(`rrrrrrrrrrrrrrrrrrrrrrrrrrrr`, this.hospital_ward_all, ward)
                    let selectedWard = {
                        label: ward.name,
                        value: ward.id,
                        origion: ward.id
                    }
                    this.$store.commit(`SET_ACTIVE_HOSPITAL_WARD`, selectedWard)
                }
                this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
                    this.$store.dispatch(`sysuser/ADD_WORKERS`)
                    // 获取转运流转表
                    this.loadTransferCirculations()
                    // 获取手术区复苏区和手术间
                    this.loadWardRooms()
                    // 处理配置文件
                    // this.handTransferConfig()
                    // 加载列表数据源
                    this.loadAllTabData()
                    // this.getMessageCount() //没什么卵用
                    this.loadAllUsers()
                    this.loadDocumentConfig()
                })
            })
        })
    },
    mounted() {
        let that = this
        this.$nextTick(() => {
            that.$refs.userCode.focus()
        })
        that.startInterval()
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.interval)
        // clearInterval(this.getMessageInterval)
        next()
    },
    methods: {
        loadToken() {
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            if (!this.user) {
                return Promise.resolve([])
            }
            return new Promise(resolve => {
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    this.doctoken = this.getToken()
                    resolve(data)
                })
            })
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.documentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocument(row) {
            let nextNode = row.next_transfer_circulation
            this.document.docno = nextNode.doc_code
            let doc = this.documentConfig.find(i => i.document_id == this.document.docno)
            if (!this.document.docno || !doc) {
                this.$message.warning(`未查到相关文书，请检查:编号为:${nextNode.doc_code},在文书系统对应的文书！`)
                return
            }
            this.document.docguid = `患者转运记录单_${row.biz_surgery_info_id}_${this.document.docno}`
            this.document.surgeryId = row.biz_surgery_info_id
            this.document.surgeryInfo = row.surgery_info
            this.document.doc = doc
            this.document.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs.doc.loadDocInfo()
            })
        },
        afterDocumentSaved(data) {
            this.confirmAddTransfer()
            this.document.dialogFormVisible = false
        },
        loadAllUsers() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
                req.then(async data => {
                    that.users = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        startInterval() {
            let that = this
            if (that.currentUser && that.currentUser.workerInfo.Enum_WorkerRole == 4) {
                // 护工 手机端护工 定时有最新 接单信息会 语音提醒3次
                clearInterval(this.interval)
                this.interval = setInterval(() => {
                    that.OrderGrabbingData()
                }, 60000)
            }
            // clearInterval(this.getMessageInterval)
            // this.getMessageInterval = setInterval(() => {
            //     that.getMessageCount()
            // }, 60000)
        },
        startNotification() {
            // 增加判断
            if (`speechSynthesis` in window) {
                for (let index = 0; index < 3; index++) {
                    let utterance = new SpeechSynthesisUtterance(`您有新的待转运订单，请及时处理！`)
                    console.log(`utterance`, utterance)
                    utterance.lang = `zh-CN`
                    window.speechSynthesis.speak(utterance)
                }
            } else {
                console.log(`您的浏览器不支持语音合成`)
            }
        },
        isHaveWithDrawRole(transferInfo) {
            let surgeryInfo = transferInfo.surgery_info
            let currentTransferCirculation = transferInfo.transfer_circulation
            if (this.currentUser && transferInfo.dic_worker_id == this.currentUser.dic_worker_id && surgeryInfo.dic_transfer_circulation_id > 0 && currentTransferCirculation && currentTransferCirculation.is_alow_withdraw) {
                return true
            } else {
                return false
            }
        },
        isHaveHandRole(transferCirculation) {
            if (transferCirculation && transferCirculation.id > 0 && this.currentUser.workerInfo && this.currentUser.workerInfo.Enum_WorkerRole) {
                return transferCirculation.worker_role_arr && transferCirculation.worker_role_arr.indexOf(this.currentUser.workerInfo.Enum_WorkerRole) > -1
            } else {
                return false
            }
        },
        selectedRooms(roomId, type) {
            if (type == 1) {
                if (this.selectedOperateRoomIds.indexOf(roomId) > -1) {
                    this.selectedOperateRoomIds = this.selectedOperateRoomIds.filter(x => x != roomId)
                } else {
                    this.selectedOperateRoomIds.push(roomId)
                }
            } else {
                if (this.selectedRecoveryRoomIds.indexOf(roomId) > -1) {
                    this.selectedRecoveryRoomIds = this.selectedRecoveryRoomIds.filter(x => x != roomId)
                } else {
                    this.selectedRecoveryRoomIds.push(roomId)
                }
            }
        },
        cancelSelectRooms(value) {
            this.selectedOperateRoomIds = []
            this.selectedRecoveryRoomIds = []
            this.loadAllTabData()
            this.$refs.item.toggle()
        },
        confirmSelectRooms(value) {
            this.loadAllTabData()
            this.$refs.item.toggle()
        },
        confirmOperTime(value) {
            this.showDatePickerPanel = false
            this.loadAllTabData()
        },
        getSearchCondition() {
            let begin = null
            let end = null
            switch (this.activeOperTime) {
            case 0:
                begin = this.$moment().format(`YYYY-MM-DD`)
                end = this.$moment().add(1, `days`).format(`YYYY-MM-DD`)
                break
            case 1:
                let weekOfDay = this.$moment().format(`E`)
                let firstday = this.$moment().subtract(weekOfDay - 1, `days`).format(`YYYY-MM-DD`)
                let endday = this.$moment().subtract(weekOfDay - 7, `days`).format(`YYYY-MM-DD`)
                begin = firstday
                end = endday
                break
            case 2:
                begin = this.$moment().startOf(`month`).format(`YYYY-MM-DD`)
                end = this.$moment().endOf(`month`).format(`YYYY-MM-DD`)
                break
            case 3:
                begin = this.$moment(this.currentDate).format(`YYYY-MM-DD`)
                end = this.$moment(this.currentDate).add(1, `days`).format(`YYYY-MM-DD`)
                break
            default:
                begin = this.$moment().format(`YYYY-MM-DD`)
                end = this.$moment().add(1, `days`).format(`YYYY-MM-DD`)
                break
            }
            let condition = {
                begin: begin,
                end: end,
                dic_hospital_ward_Id: this.active_hospital_ward.origion,
                operatingRoomIds: this.selectedOperateRoomIds,
                recoveryWardIds: this.selectedRecoveryRoomIds
            }
            return condition
        },
        loadAllTabData() {
            let that = this
            let searchCondition = that.getSearchCondition()
            return new Promise((resolve, reject) => {
                let data = {
                    begin: searchCondition.begin,
                    end: searchCondition.end,
                    dic_hospital_ward_Id: searchCondition.dic_hospital_ward_Id || 0,
                    operatingRoomIds: searchCondition.operatingRoomIds || [],
                    recoveryWardIds: searchCondition.recoveryWardIds || [],
                    group_name: that.activeTab,
                    visit_no: that.scan_userCode || that.visitNo
                }

                let req = this.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/GetTransferList`, data)
                let req2 = this.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/GetTransferGroupCount`, data)
                that.myaxios.all(req, req2).then(([data, data1]) => {
                    that.allTransferInfoList = data
                    // 前端数据过滤,转运状态文字,前端过滤
                    if (that.activeTransferStatus != `全部` && that.activeTransferStatus != ``) {
                        that.transferInfoList = _.filter(data, transfer => {
                            return transfer.transfer_status == that.activeTransferStatus
                        })
                    } else {
                        that.transferInfoList = data
                    }
                    that.handTransferConfig(data1)
                    that.reloadAllTransferCirculations(data1)
                    that.reloadTransferStatusData(data1)
                    that.finished = true
                    resolve()
                }).catch(e => {
                    that.finished = true
                })
            })
        },
        // 获取区域和房间
        loadWardRooms() {
            let that = this
            let wards = _.filter(this.ward_auth && this.ward_auth.length > 0 ? this.ward_auth : [], ward => {
                return ward.groupId == that.active_hospital_ward.origion
            })
            if (wards && wards.length > 0) {
                that.operateWards = wards
            }
        },
        loadTransferCirculations() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.mobile_get(`/api/TransferEvent/TransferCirculation/Get`)
                req.then(async data => {
                    that.transferCirculations = data
                    resolve()
                }).catch(e => reject(e))
            })
        },
        // getMessageCount() {
        //     return new Promise((resolve, reject) => {
        //         let req = this.myaxios.getNoloading(
        //             `/api/Operation/MessageReceive/GetTransferUnReadCount?from=${this.$moment()
        //                 .add(-7, `Day`)
        //                 .format(`YYYY-MM-DD`)}&to=${this.$moment().format(`YYYY-MM-DD`)}`
        //         )
        //         req.then(data => {
        //             this.messagebadge = data
        //             resolve()
        //         }).catch(e => {
        //             console.log(e)
        //         })
        //     })
        // },
        OrderGrabbingData() {
            let that = this
            let searchCondition = that.getSearchCondition()
            return new Promise((resolve, reject) => {
                let data = {
                    begin: searchCondition.begin,
                    end: searchCondition.end,
                    dic_hospital_ward_Id: searchCondition.dic_hospital_ward_Id || 0,
                    operatingRoomIds: [],
                    recoveryWardIds: [],
                    group_name: `全部`,
                    visit_no: ``
                }

                let req = this.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/GetTransferList`, data)
                req.then((data) => {
                    let list = _.filter(data, { transfer_status: `护工接患者中` }).map(i => i.transfer_id)
                    let equal = _.isEqual(list, that.orderGrabbingList)
                    if (!equal) {
                        that.orderGrabbingList = list
                        if (that.orderGrabbingList.length > 0) {
                            that.startNotification()
                            if (that.activeTab == `全部`) {
                                that.allTransferInfoList = data
                                // 前端数据过滤,转运状态文字,前端过滤
                                if (that.activeTransferStatus != `全部` && that.activeTransferStatus != ``) {
                                    that.transferInfoList = _.filter(data, transfer => {
                                        return transfer.transfer_status == that.activeTransferStatus
                                    })
                                } else {
                                    that.transferInfoList = data
                                }
                            }
                        }
                    }
                    resolve(that.orderGrabbingList)
                }).catch(e => {
                })
            })
        },
        handTransferConfig(tabrows) {
            let that = this
            if (this.transferGroupConfig && this.transferGroupConfig.length > 0 && this.currentUser && this.currentUser.workerInfo.Enum_WorkerRole) {
                this.tabsGroup = []
                // 当前人是什么角色，拿对应角色的大类页签
                let configset = _.find(this.transferGroupConfig, function(config) {
                    return config.enum_worker_role == that.currentUser.workerInfo.Enum_WorkerRole.toString()
                })
                if (configset) {
                    let tabRowGroups = tabrows && tabrows.group_info
                    let configsetcopy = _.cloneDeep(configset)
                    configsetcopy.group_info.unshift({ lable: `全部` })
                    this.currentRoleConfig = configsetcopy
                    let tabs = configsetcopy.group_info.map(i => {
                        let tabname = tabRowGroups && _.find(tabRowGroups, function(tab) {
                            return tab.lable == i.lable
                        }) || null
                        let rows = tabname && tabname.rows || 0
                        return { title: `${i.lable}(${rows})`, name: `${i.lable}` }
                    })
                    this.tabsGroup = this.tabsGroup.concat(tabs)
                }
            }
        },
        reloadTransferStatusData(tabrows) {
            let that = this
            let tabRowGroups = tabrows && tabrows.group_info
            let totalRows = 0
            this.transferStatus = []
            if (that.activeTab == `全部`) {
                this.transferStatus = that.allTransferStatus
                return
            }
            // 转运状态下拉源：如果配置了 surgery_status，取 surgery_status，没有 取 transfer_status
            let tabconfigset = _.find(this.currentRoleConfig.group_info, function(tab) {
                return tab.lable == that.activeTab
            })
            if (tabconfigset) {
                let tabname = tabRowGroups && _.find(tabRowGroups, function(tab) {
                    return tab.lable == that.activeTab
                }) || null
                totalRows = tabname && tabname.rows
                let statusArr = tabname && tabname.transfer_status_info
                let tmpStatusObj = []
                if (tabconfigset.surgery_status && tabconfigset.surgery_status != ``) {
                    let transferSurgeryStatus = tabconfigset.surgery_status.split(`|`)
                    if (transferSurgeryStatus && transferSurgeryStatus.length > 0) {
                        transferSurgeryStatus.map(s => {
                            let StatusObj = _.find(that.allTransferStatus, transfer => {
                                return transfer.surgery_status == s
                            })
                            if (StatusObj) {
                                tmpStatusObj.push(StatusObj)
                            }
                        })
                    }
                } else {
                    let transferStatusObj = []
                    let transferStatus = tabconfigset.transfer_status.split(`|`)
                    if (transferStatus && transferStatus.length > 0) {
                        transferStatusObj = transferStatus.map(s => {
                            let name = that.getTransferStatusName(s)
                            return { text: name, value: name }
                        })
                    }
                    tmpStatusObj = _.uniqBy(transferStatusObj, `value`)
                }
                let statusObjRows = tmpStatusObj.map(i => {
                    let statusObjName = statusArr.find(s => s.transfer_status == i.value)
                    let rows = statusObjName && statusObjName.rows || 0
                    return { text: `${i.value}(${rows})`, value: `${i.value}` }
                })
                this.transferStatus = [{ text: `全部(${totalRows})`, value: `全部` }].concat(statusObjRows)
            }
        },
        reloadAllTransferCirculations(tabrows) {
            let that = this
            let surgeryStatus = [
                { text: `已排程`, value: `已排程`, surgery_status: `20` },
                { text: `手术中`, value: `手术中`, surgery_status: `30` },
                { text: `手术结束`, value: `手术结束`, surgery_status: `40` },
                { text: `复苏结束`, value: `复苏结束`, surgery_status: `60` }
            ]
            let stateNames = _.uniqBy(that.transferCirculations, `data_state_name`).map(i => {
                return { text: i.data_state_name, value: i.data_state_name, surgery_status: `-1` }
            })
            let tmpStatusObj = surgeryStatus.concat(stateNames)
            let tabRowGroups = tabrows && tabrows.group_info
            let totalRows = 0
            let tabname = tabRowGroups && _.find(tabRowGroups, function(tab) {
                return tab.lable == that.activeTab
            }) || null
            totalRows = tabname && tabname.rows
            let statusArr = tabname && tabname.transfer_status_info
            let statusObjRows = tmpStatusObj.map(i => {
                let statusObjName = statusArr.find(s => s.transfer_status == i.value)
                let rows = statusObjName && statusObjName.rows || 0
                return { text: `${i.value}(${rows})`, value: `${i.value}`, surgery_status: i.surgery_status }
            })
            this.allTransferStatus = [{ text: `全部(${totalRows})`, value: `全部`, surgery_status: `-1` }].concat(statusObjRows)
        },
        onLoad() {},
        onRefresh() {
            let that = this
            this.loadAllTabData()
                .then(data => {
                    Toast(`刷新成功`)
                    that.refreshing = false
                })
                .catch(() => {
                    that.refreshing = false
                })
        },
        logoutbody() {
            Dialog.confirm({
                message: `确认退出`
            })
                .then(() => {
                    this.$router.replace(`/t_login`).then(() => {
                        sessionStorage.removeItem(`token`)
                        sessionStorage.removeItem(`doctoken`)
                    })
                })
                .catch(() => {
                    // on cancel
                })
        },
        setscanActive() {
            setTimeout(() => {
                this.scanActive = true
            }, 2000)
        },
        openScan() {
            let that = this
            this.scanActive = false
            this.setscanActive()
            // 存在cordova在打开
            // eslint-disable-next-line no-undef
            if (typeof cordova != `undefined`) {
                // eslint-disable-next-line no-undef
                if (!cordova.plugins.barcodeScanner) {
                    Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
                }
                // eslint-disable-next-line no-undef
                cordova.plugins.barcodeScanner.scan(
                    function(result) {
                        that.scan_userCode = result.text
                        that.loadAllTabData()
                    },
                    function(error) {
                        Dialog({ title: `提示信息`, message: `扫码失败` + error })
                    },
                    {
                        preferFrontCamera: false, // iOS and Android
                        showFlipCameraButton: true, // iOS and Android
                        showTorchButton: true, // iOS and Android
                        torchOn: false, // Android, launch with the torch switched on (if available)
                        saveHistory: true, // Android, save scan history (default false)
                        prompt: `请扫描二维码`, // Android
                        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                        // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                        orientation: `portrait`, // Android only (portrait|landscape), default unset so it rotates with the device
                        disableAnimations: true, // iOS
                        disableSuccessBeep: false // iOS and Android
                    }
                )
            } else {
                Dialog({ title: `提示信息`, message: `当前设备不支持扫码` })
            }
        },
        goPath(transferInfo, path) {
            this.$router.push({ name: path, query: { surgeryId: transferInfo.biz_surgery_info_id }, params: { surgeryInfo: transferInfo.surgery_info } }).catch(err => err)
        },
        goTransDetail(transferInfo) {
            let button = []
            let nextTransferCirculation = transferInfo.next_transfer_circulation
            let btn = {
                transferId: transferInfo.transfer_id,
                surgeryId: transferInfo.biz_surgery_info_id,
                next_dic_transfer_circulation: nextTransferCirculation,
                next_dic_transfer_circulation_id: nextTransferCirculation && nextTransferCirculation.id || 0
            }

            if (this.isHaveWithDrawRole(transferInfo)) {
                let cehuibtn = Object.assign({}, btn, {
                    is_withdraw: true,
                    button_name: `撤回`
                })
                button.push(cehuibtn)
            }

            if (this.isHaveHandRole(nextTransferCirculation) && nextTransferCirculation && nextTransferCirculation.buttonNames) {
                _.forEach(nextTransferCirculation.buttonNames, bname => {
                    if (bname) {
                        let nodebtn = Object.assign({}, btn, {
                            is_withdraw: false,
                            button_name: bname
                        })
                        button.push(nodebtn)
                    }
                })
            }
            this.$router.push({ name: `TransferInfo`,
                query: { surgeryId: transferInfo.biz_surgery_info_id,
                    transferId: transferInfo.transfer_id,
                    from: JSON.stringify({
                        path: this.$route.path,
                        query: this.$route.query
                    }) },
                params: { surgeryInfo: transferInfo.surgery_info, buttons: button } }).catch(err => err)
        },
        handlerTransfer(transferInfo, type, bname) {
            let nextTransferCirculation = transferInfo.next_transfer_circulation
            this.showRemarkObj.btnName = bname
            this.showRemarkObj.remark = ``
            this.showRemarkObj.id = transferInfo.transfer_id
            this.showRemarkObj.biz_surgery_info_id = transferInfo.biz_surgery_info_id
            this.showRemarkObj.next_dic_transfer_circulation_id = nextTransferCirculation && nextTransferCirculation.id || 0
            this.showRemarkObj.is_withdraw = type == 2
            this.showRemarkObj.next_dic_transfer_circulation = nextTransferCirculation
            if (nextTransferCirculation && nextTransferCirculation.doc_code) {
                this.loadDocument(transferInfo)
            } else if (nextTransferCirculation && nextTransferCirculation.button_name == `接患者` || this.showRemarkObj.is_withdraw) {
                // 接患者或撤回需要写理由
                this.showRemarkObj.isShow = true
            } else {
                this.confirmAddTransfer()
            }
        },
        confirmAddTransfer() {
            let that = this
            return new Promise((resolve, reject) => {
                let data = {
                    id: that.showRemarkObj.id, // 当前转运记录对应id
                    button_name: that.showRemarkObj.btnName,
                    biz_surgery_info_id: that.showRemarkObj.biz_surgery_info_id,
                    is_withdraw: that.showRemarkObj.is_withdraw, // 是否是撤回操作
                    remark: that.showRemarkObj.remark || ``,
                    next_dic_transfer_circulation_id: that.showRemarkObj.next_dic_transfer_circulation_id // 下一转运节点ID，即点击的按钮对应的id
                }
                let req = that.myaxios.mobile_post(`/api/TransferEvent/TransferOccurEvent/PostTransfer`, data)
                req.then(async data => {
                    if (!that.showRemarkObj.is_withdraw) {
                        let nextNode = that.showRemarkObj.next_dic_transfer_circulation
                        if (nextNode.message_template) {
                            // 定义了消息模板，则发消息
                            that.sendMessage(data)
                        }
                    } else {
                        that.withDrawMessage(that.showRemarkObj.id)
                    }
                    that.showRemarkObj.isShow = false
                    that.loadAllTabData()
                    resolve()
                }).catch(e => reject(e))
            })
        },
        sendMessage(data) {
            let nextNode = data.next_transfer_circulation
            // 消息发送
            let messageheader = this.createMessageHeader(data)
            messageheader.ac_sys_user_roles = nextNode.worker_role_arr.join(`,`)
            this.saveMessage(messageheader)
        },
        createMessageHeader(data) {
            let surgeryInfo = data.surgery_info
            let currentNode = this.showRemarkObj.next_dic_transfer_circulation
            let title = `${data.modifier}给你发了消息`
            let content = `${currentNode.message_template}${data.remark != `` ? `,特别关注:` + data.remark : ``} `
            content = content.replace(`{患者姓名}`, surgeryInfo.patient_name)
            content = content.replace(`{手术医生}`, surgeryInfo.surgeon)
            content = content.replace(`{登陆用户}`, this.currentUser.dic_worker_name)
            let message = {
                content: content,
                isExtraBtnClick: false,
                send_type: 2,
                title: title,
                is_alow_receive: true,
                biz_id: data.id,
                biz_type: `6`,
                enum_message_status: 1
            }
            return message
        },
        getReceiverIds(receiverRoles) {
            let that = this
            let roleWorkerIds = _.filter(this[`sysuser/workers`], worker => {
                return receiverRoles.indexOf(worker.enum_worker_role) > -1
            }).map(i => i.id)
            let roleUserIds = that.getAcUserId(roleWorkerIds)
            return roleUserIds || []
        },
        getAcUserId(roleWorkerIds) {
            let userids = _.filter(this.users, user => {
                return user.is_deleted == false && roleWorkerIds.indexOf(user.dic_worker_id) > -1
            }).map(i => i.id)
            return userids || []
        },
        saveMessage(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.mobile_post(`/api/Operation/MessageHeader/Save`, row)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        withDrawMessage(tranferId) {
            this.myaxios.delete(`/api/Operation/MessageHeader/DeleteByBizId?bizId=${tranferId}`)
        },
        getTransferStatusName(status) {
            let node = _.find(this.transferCirculations, function(node) {
                return node.id == parseInt(status)
            })
            return (node && node.data_state_name) || `配置的转运状态不存在`
        },
        handlerOperTime() {
            if (this.activeOperTime == 3) {
                this.showDatePickerPanel = true
            } else {
                this.loadAllTabData()
            }
        },
        filterTransferStatus() {
            let that = this
            that.transferInfoList = that.activeTransferStatus == `全部` ? that.allTransferInfoList : _.filter(that.allTransferInfoList, transfer => {
                return transfer.transfer_status == that.activeTransferStatus
            })
        },
        initActive() {
            this.activeOperTime = 0
        }
    },
    watch: {
        activeTab: function(newVlaue, oldValue) {
            // 切换tab大类页签时,把下拉列表重新恢复成默认值
            // this.initActive()
            // 切换tab大类页签重新加载 转运状态下拉
            // 重新请求数据
            this.activeTransferStatus = `全部`
            this.loadAllTabData()
        },
        // activeOperTime: function(newVlaue, oldValue) {
        //     this.handlerOperTime()
        // },
        activeTransferStatus: function(newVlaue, oldValue) {
            this.filterTransferStatus()
        },
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_transferList`) {
                // 重新请求数据
                this.loadAllTabData()
                this.startInterval()
            }
        },
        activeBottomTabItem: function(newval, oldval) {
            if (newval == 0) {
                this.$router.push({ path: `m_baseinfo` }).catch(err => err)
            }
            if (newval == 1) {
                this.$router.push({ name: `TransferList` }).catch(err => err)
            }
            if (newval == 2) {
                this.$router.push({ name: `MyInfo` }).catch(err => err)
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.page {
    background-color: rgba(242, 242, 246, 1);
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.box_1 {
    background: url(/static/img/mobile/mobile_base_header.png) 100% no-repeat;
    background-size: 100% 100%;
    padding: 13px 15px 6px 16px;
}
.group_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    margin: 19px 1px 0 0;
    padding: 5px 211px 5px 13px;
}

.image-text_25 {
    width: 119px;
}

.label_1 {
    width: 32px;
    height: 22px;
}

.section_1 {
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: flex-center;
    padding: 0.267rem 0.427rem 0.267rem 0.427rem;
}

.icon_1 {
    width: 0.64rem;
    height: 0.64rem;
    margin: 0.16rem 0 0.16rem 0;
}

.text_1 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 0.426rem;
    font-family: PingFangSC-Regular;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
    line-height: 0.587rem;
    margin: 0.187rem 0 0 0.107rem;
}

.input_1 {
    background-color: rgba(241, 244, 246, 1);
    border-radius: 20px;
    margin-left: 0.267rem;
    width: 5.334rem;
    height: 0.85rem;
    padding: 0.05rem 0.187rem 0.2rem 0.22rem;
}

.el-input /deep/ .el-input__inner {
    height: 0.75rem;
    line-height: 0.75rem;
    background-color: #f1f4f6;
    border: none;
}

.block_3 {
    margin: 0.054rem 0 0.027rem 0.4rem;
}

.icon_2 {
    width: 0.534rem;
    height: 0.534rem;
    margin: 0.027rem 0 0.027rem 0;
}

.btnconfirm {
    padding: 5px 16px;
    display: flex;
    justify-content: space-between;
}

.btnselectroom {
    background: #07c160 !important;
    color: #ffffff;
    width: 100px;
}

.text_2 {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 0.426rem;
    font-family: PingFangSC-Regular;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 0.587rem;
    margin-left: 0.16rem;
}

.text_3 {
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 9px;
    font-family: PingFangSC-Regular;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 13px;
    margin-left: -0.125rem;
}

.thumbnail_1 {
    width: 0.027rem;
    height: 0.534rem;
    margin: 0.027rem 0 0.027rem 0;
}

.section_2 {
    // padding-bottom: 0.827rem;
    flex: 1;
}

.section_5 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: -1px;
    padding: 10px 40px 9px 30px;
}

.thumbnail_39 {
    width: 20px;
    height: 20px;
    align-self: center;
}

.text-group_31 {
    overflow-wrap: break-word;
    color: rgba(0, 150, 136, 1);
    font-size: 10px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}

.text-group_34 {
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 16px;
}
.tabs_1 {
    background-color: rgba(255, 255, 255, 1);
}

.tabs_1 /deep/ .van-popup{
    overflow-y:hidden !important;
}
.dropdownRooms {
    display: flex;
    height:320px;
    overflow-y: scroll;
}

.wardpanel {
    text-align: left;
    font-size: 20px;
    padding: 5px;
}

.roompanel {
    display: flex;
    flex-wrap: wrap;

    .room {
        padding: 5px 10px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 15px;
        color: #333333;
        line-height: 37px;
        margin: 6px;
    }

    .room_active {
        background: #e0f2f1;
        color: var(--primary-color, #009688);
    }
}

.content {
    height: 200px;
    overflow: auto;
    background-color:#f1f4f6;
    .surgeryInfo {
        border-radius: 4px;
        padding: 8px 12px 12px 12px;
        text-align: left;
        width: 96%;
        background: #ffffff;
        margin: 10px auto;
        font-size: 14px;
        .header {
            padding: 10px 0px;
            .name {
                overflow-wrap: break-word;
                color: rgba(51, 51, 51, 1);
                font-size: 16px;
                font-weight: 500;
                text-align: left;
                white-space: nowrap;
                line-height: 26px;
            }
            .patientInfo{
                overflow-wrap: break-word;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
                font-weight: normal;
                text-align: left;
                white-space: nowrap;
                line-height: 20px;
                margin-top: 6px;
            }
        }

        .middle {
            background-color: rgba(245, 245, 245, 1);
            padding: 8px 4px 8px 8px;
            .surgery {
                padding: 2px 0px;
                overflow: hidden;
                flex:1;
                .rowmargin{
                    margin-top: 6px;
                }
                .patientTitle {
                    overflow-wrap: break-word;
                    color: rgba(153, 153, 153, 1);
                    font-size: 13px;
                    font-weight: normal;
                    text-align: left;
                    white-space: nowrap;
                    line-height: 20px;
                }
                .patientContent {
                    overflow-wrap: break-word;
                    color: rgba(102, 102, 102, 1);
                    font-size: 13px;
                    font-weight: normal;
                    text-align: left;
                    white-space: nowrap;
                    line-height: 20px;
                }
            }
        }

        .bottom {
            display: flex;
            justify-content: flex-end;
            .btnTrans {
                background: #e0f2f1;
                margin: 5px 2px 5px 10px;
                height: 29px;
                padding: 0px 20px;
                color: var(--primary-color, #009688);
                max-width: 110px;
                overflow-wrap: break-word;
                white-space: nowrap;
            }
        }
    }
}

.text-wrapper_1 {
    width: 6.72rem;
}

.text {
    overflow-wrap: break-word;
    font-size: 0.426rem;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
    line-height: 0.587rem;
}

.text-wrapper_1 /deep/ .mint-tab-item {
    flex: 0;
}

.text-wrapper_1 /deep/ .is-selected {
    border-bottom: none;
    color: rgb(0, 150, 136);
}

.text /deep/ .mint-tab-item-label {
    font-size: inherit;
}

.group_1 {
    margin: 0.187rem 5.014rem 0 0;
}

.box_2 {
    background-color: rgba(0, 150, 136, 1);
    width: 1.707rem;
    height: 0.054rem;
}

.text-wrapper_base {
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    padding: 0.427rem 0.427rem 0.427rem 0.427rem;
}

.text-wrapper_2 {
    margin-top: 0.267rem;
}

.text_base {
    overflow-wrap: break-word;
    font-size: 0.426rem;
    font-family: PingFangSC-Regular;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 0.427rem;

    .text_base_label {
        color: rgba(153, 153, 153, 1);
    }

    .text_base_value {
        color: rgba(51, 51, 51, 1);
    }
}

.box_4 {
    background-color: rgba(255, 255, 255, 1);
    padding: 0.64rem 2.8rem 9.12rem 2.854rem;
}

.image_2 {
    width: 3.947rem;
    height: 3.307rem;
}

.text-group_1 {
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 15px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 21px;
    /deep/ .el-input__inner{
        background-color: transparent;
        border: 0;
        line-height: 21px;
        height:21px;
        width:210px;
    }
    /deep/ .el-input__suffix{
        right:-100px;
    }
}

.section_3 {
    background-color: rgba(255, 255, 255, 1);
    position: fixed;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 80%;
    align-items: center;
}

.button_1 {
    background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
    border-radius: 4px;
    padding: 0.24rem 3.92rem 0.24rem 3.92rem;
    width: 100%;
}

.text_25 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 0.426rem;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    width: 100%;
    white-space: nowrap;
    line-height: 0.587rem;
}

.timelines {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    margin-top: 0.267rem;
    padding: 0.32rem 0.32rem 0.587rem 0.427rem;

    .image-text_1 {
        width: 2.8rem;
        margin-right: 1.894rem;
    }

    .icon_3 {
        width: 0.587rem;
        height: 0.587rem;
    }

    .displayorder {
        background-color: rgba(0, 150, 136, 1);
        border-radius: 50%;
        line-height: 0.256rem;
        height: 0.62rem;
        width: 0.62rem;

        .order_num {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.373rem;
            font-family: PingFangSC-Regular;
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
            line-height: 0.587rem;
        }
    }

    .button_confirm {
        background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
        border-radius: 4px;
        padding: 0.12rem 0.24rem 0.12rem 0.24rem;
        margin: 2px 0px;
    }

    .text-group_1 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.4rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
        margin: 0 1.254rem 0 0.3rem;
    }

    .box_3 {
        width: 4.427rem;
        margin-left: 0.267rem;
    }

    .group_6 {
        background-color: rgba(0, 150, 136, 1);
        width: 0.027rem;
        height: 0.64rem;
        margin-top: 0.214rem;
    }

    .text_5 {
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.534rem;
        padding-left: 0.534rem;
    }

    .text_6 {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.4rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 0.56rem;
        margin-top: 0.347rem;
    }
}

.box_7 {
    background-color: rgba(0, 0, 0, 0.55);
    width: 100%;
    // height: 15.067rem;
    height: 100%;

    .group_11 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 12px 12px 0px 0px;
        padding-top: 0.427rem;
    }

    .text_confirm {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 0.9);
        font-size: 0.48rem;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 0.694rem;
        align-self: center;
    }

    .text-wrapper_confirm {
        background-color: rgba(255, 255, 255, 1);
        width: 9.6rem;
        // margin-top: 0.4rem;
        padding: 0.427rem 0.2rem 0.427rem 0.25rem;
    }

    .text_confirm_detail {
        overflow-wrap: break-word;
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;
    }

    .confirm_box_button {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        margin-top: 0.027rem;
        padding: 0.24rem 0.427rem 0.24rem 0.427rem;
    }

    .button_2 {
        background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
        border-radius: 4px;
        padding: 0.24rem 1.627rem 0.24rem 1.627rem;
    }

    .text_31 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 0.426rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.587rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/TransferList.vue